(function () {
  function setCollectionHeading() {
    var heading = document.querySelector('.shop-hero__heading');
    var isFrench = document.documentElement.lang.toLowerCase().indexOf('fr') === 0;
    if (heading) {
      heading.innerHTML = isFrench
        ? 'Acheter un <em>appareil médical</em>'
        : 'Shop for a <em>Medical Device</em>';
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setCollectionHeading);
  } else {
    setCollectionHeading();
  }
})();
